module.exports = __webpack_public_path__ + "img/spider.570222e8.png";